var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100.5 100.5",
    style: {
      enableBackground: "new 0 0 100.5 100.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M89.955,10.417H36.768c-4.943,0-8.965,4.02-8.965,8.961v9.727c0,0.829,0.671,1.5,1.5,1.5s1.5-0.671,1.5-1.5v-9.727 c0-3.287,2.676-5.961,5.965-5.961h53.187c3.292,0,5.97,2.674,5.97,5.961v36.609c0,3.287-2.678,5.961-5.97,5.961H70.026 c-0.025,0-0.049,0.006-0.074,0.007c-0.025-0.001-0.048-0.007-0.074-0.007h-13.04c-0.828,0-1.5,0.672-1.5,1.5v15.495H41.02 c-0.829,0-1.5,0.672-1.5,1.5s0.671,1.5,1.5,1.5h15.819h13.04h15.832c0.828,0,1.5-0.672,1.5-1.5s-0.672-1.5-1.5-1.5H71.379V64.948 h18.576c4.946,0,8.97-4.02,8.97-8.961V19.378C98.925,14.437,94.901,10.417,89.955,10.417z M58.339,78.943V64.948h10.04v13.995 H58.339z",
    fill: "#4ee44e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.282,75.095c5.586,0,11.149-2.296,15.138-6.793c0,0,0,0,0,0c7.399-8.345,6.633-21.152-1.709-28.55 c-8.344-7.396-21.15-6.629-28.548,1.709c-7.061,7.965-6.666,19.984,0.636,27.496l-2.459,2.775l-0.568-0.503 c-0.619-0.548-1.562-0.492-2.111,0.122L1.552,83.756c-0.266,0.297-0.403,0.687-0.38,1.084c0.022,0.397,0.201,0.771,0.498,1.035 l3.493,3.121c0.286,0.256,0.643,0.382,0.999,0.382c0.412,0,0.822-0.169,1.118-0.5L18.4,76.453c0.266-0.297,0.403-0.688,0.38-1.087 c-0.023-0.398-0.205-0.771-0.503-1.036l-0.689-0.61l2.453-2.768C23.666,73.72,27.978,75.095,32.282,75.095z M6.044,85.761 l-1.256-1.122l9.007-10.056c0.079,0.25,0.219,0.485,0.43,0.671c0.26,0.23,0.579,0.34,0.901,0.36L6.044,85.761z M19.408,43.452 c3.398-3.83,8.134-5.784,12.893-5.784c4.065,0,8.146,1.427,11.42,4.328c7.104,6.3,7.757,17.208,1.455,24.315 c-6.3,7.103-17.209,7.756-24.314,1.454C13.76,61.466,13.108,50.559,19.408,43.452z",
    fill: "#4ee44e"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.475,
    cy: 22.623,
    r: 1.79
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReview);
export default __webpack_public_path__ + "static/media/review.b9d38b23870c155299cb2ce273470ded.svg";
export { ForwardRef as ReactComponent };